import type { FC } from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import ArrowLeftIcon from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import { paths } from "src/paths";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { VideoPlayer } from "src/components/video-player";
import { videos } from "src/videos";

interface ProductDemoPlayerProps {
  onClose?: () => void;
  open?: boolean;
  openCalendly: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ProductDemoPlayer: FC<ProductDemoPlayerProps> = (props) => {
  const { onClose, open = false, openCalendly } = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={"md"}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "background.paper",
            p: 2,
          }}
        >
          <Button
            color="inherit"
            startIcon={
              <SvgIcon>
                <ArrowLeftIcon />
              </SvgIcon>
            }
            onClick={onClose}
          >
            Close
          </Button>
        </Box>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            mb: 2,
            mt: 0,
          }}
        >
          <Box
            sx={{
              mb: 5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              maxWidth: "100%",
              alignItems: "center",
            }}
          >
            <Box sx={{ maxWidth: 600, width: "100%" }}>
              <VideoPlayer
                src={videos.productDeepDive}
                videoId="vimeo-product-demo"
                title="Snug - Product Demo"
              />
            </Box>
            <Typography
              color="text.secondary"
              sx={{ my: 1, textAlign: "center", px: 5, mb: 0 }}
              variant="body1"
            >
              Watch the 30 minute demo to see the full product experience for you, your clients, and your team. When you're ready to get onboard,
              follow the "Complete Onboarding" buttons on the dashboard.{" "}
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
              <Button
                startIcon={<CalendarMonthOutlinedIcon />}
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  onClose?.(); // Safely calling onClose if it is defined
                  openCalendly(true);
                }}
              >
                Book a Guided Tour
              </Button>
              <Button
                variant="text"
                href={paths.dashboard.tutorials}
              >
                Tutorials
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  window.open(
                    "https://s3.us-east-2.amazonaws.com/assets.getsnug.com/files/toolkit/Snug+Pricing+-+March+2025.pdf",
                    "_blank"
                  )
                }
              >
                Pricing
              </Button>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

ProductDemoPlayer.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
